import {useState} from "react";
import {DialogContent} from "@mui/material";
import {EcommerceDashboardModalPaymentLoader} from "./EcommerceDashboardModalPaymentLoader";
import {EcommerceDashboardModalPaymentSuccess} from "./EcommerceDashboardModalPaymentSuccess";
import {Transaction} from "../../../../../store/api/interface/ecommerce";
import {EcommerceDashboardModalPaymentRejected} from "./EcommerceDashboardModalPaymentRejected";
import {EcommerceDashboardModalPaymentExpired} from "./EcommerceDashboardModalPaymentExpired";

interface IModalPaymentContext {
    close: () => void;
    transaction: Transaction
    updateTransaction: (value:Transaction)=>  void
}
export const  EcommerceDashboardModalPaymentContext = ({close, transaction, updateTransaction}: IModalPaymentContext) => {

    const [statusPayment, setStatusPayment] = useState<"pending"| 'completed'|'rejected'|'expired'>("pending");

    return (
        <DialogContent>
            {statusPayment === "pending" && <EcommerceDashboardModalPaymentLoader updateTransaction={updateTransaction} transaction={transaction} close={close}  setStatus={setStatusPayment}/>}
            {statusPayment === "completed" && <EcommerceDashboardModalPaymentSuccess close={close} transaction={transaction}/>}
            {statusPayment === "rejected" && <EcommerceDashboardModalPaymentRejected close={close}/>}
            {statusPayment === "expired" && <EcommerceDashboardModalPaymentExpired close={close}/>}
        </DialogContent>
    );
};